import { lazy, Suspense } from "react";
import { AuthSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/AuthenticationPages/resetPassword"));

const ResetPassword = () => {
  return (
    <Suspense fallback={<AuthSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default ResetPassword;
